import { Stack, Text } from "@chakra-ui/react"
import type { FC } from "react"
import SwitchNetwork from "@/common/components/SwitchNetwork"
import type { ChainId } from "@/query/graphql"
import { getChainIdParams } from "@/web3/helpers/chainId"
import { getChainReferenceName } from "@/web3/helpers/chainReference"

type Props = {
  requiredChainId: ChainId
  chainReference: number
}
const PreCheckNetworkSelection: FC<Props> = ({
  requiredChainId,
  chainReference,
}) => {
  const { reference: requiredChainReference } =
    getChainIdParams(requiredChainId)

  return (
    <Stack align="center" pt={4} px={12} spacing={4}>
      <Text color="gray.500" textAlign="center" textStyle="body.bold.md">
        You currently have selected {getChainReferenceName(chainReference)} but
        you need to be connected to{" "}
        {getChainReferenceName(requiredChainReference)}
      </Text>
      <SwitchNetwork hasMessage={false} requiredChainId={requiredChainId} />
    </Stack>
  )
}

export default PreCheckNetworkSelection
